import Typography from '@mui/material/Typography';
import {env} from '../../config/env';

export default function LoginHeader() {
  return (
    <>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Welcome to {env.appName}
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom align="center">
        Study smarter together with your family
      </Typography>
    </>
  );
}
